import { useEffect, useRef, useState } from "react";

const AUTO_HIDE_MS = 2500;

// Port of gallery.ts's fsCurrentIsVideo-gated auto-hide behavior (the
// regression this session already fixed once: a static photo has no
// playback to obstruct, so its controls must never auto-hide - only
// re-arm the 2.5s timer for videos). isVideo should reflect the
// CURRENTLY DISPLAYED item and change identity when navigating to a
// different item, mirroring displayMediaAtIndex()'s per-item
// showFsControls(isVid) call.
export function useAutoHideControls(isVideo: boolean) {
  const [hidden, setHidden] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  function clearTimer() {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  }

  function show(autoHide: boolean) {
    setHidden(false);
    clearTimer();
    if (autoHide) {
      timerRef.current = setTimeout(() => setHidden(true), AUTO_HIDE_MS);
    }
  }

  function hide() {
    setHidden(true);
    clearTimer();
  }

  function toggle() {
    if (hidden) show(isVideo);
    else hide();
  }

  function onActivity() {
    show(isVideo);
  }

  useEffect(() => {
    show(isVideo);
    return clearTimer;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isVideo]);

  return { hidden, show, hide, toggle, onActivity };
}
